import { AdvertiserDashboardPage } from './../../enums/DashboardType.enum';
import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ICollapsibleNavItemProps } from '@amobee/component-library';
import { AutoCompleteMappedItem } from '../../../common/components/auto-complete/auto-complete.component';
import { MarketAdvertiserContextService } from '../../services/market-advertiser-context.service';

@Component({
  selector: 'advertiser-dashboard',
  templateUrl: './advertiser-dashboard.component.html',
  styleUrls: ['./advertiser-dashboard.component.scss']
})
export class AdvertiserDashboardComponent implements OnInit {

  public collapsibleItems: ICollapsibleNavItemProps[];

  public autoCompletetConfig = {
    advertiserAutoCompletePromise: this.mktAdvCxtService.autoCompletePromiseSetUp('ADVERTISER'),
    handleOnAdvertiserSelect: (item: AutoCompleteMappedItem) => {
      this.router.navigate(['advertiser-dashboard', item.value, 'planner-list'], { queryParams: { marketId: this.advertiserInfo.marketId } });
    },
    responseMapper: this.mktAdvCxtService.autoCompleteResponseMapper
  };

  handleOnMarketSelect(item) {
    this.router.navigate(['market-dashboard', item.props.marketId, 'advertiser-list']);
  }

  handleOnMarketSelectRef = this.handleOnMarketSelect.bind(this);

  public advertiserInfo: any;
  public currentDashBoardPage: string;
  public advertiserDashboardPage = AdvertiserDashboardPage;

  constructor(
    public ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private mktAdvCxtService: MarketAdvertiserContextService
  ) { }

  ngOnInit() {
    this.currentDashBoardPage = this.route.snapshot.url[0].path;
    this.collapsibleItems = [
      {
        icon: 'List',
        label: 'Plans',
        title: 'Plans',
        active: this.currentDashBoardPage == AdvertiserDashboardPage.Plans,
        linkProps: {
          onClick: () => {
            this.router.navigate(['..', 'planner-list'], { relativeTo: this.route, queryParams: { marketId: this.advertiserInfo.marketId } });
          }
        }
      },
      {
        icon: 'List',
        label: 'Deals',
        title: 'Deals',
        active: this.currentDashBoardPage == AdvertiserDashboardPage.Deals,
        linkProps: {
          onClick: () => {
            this.router.navigate(['..', 'deal-list'], { relativeTo: this.route, queryParams: { marketId: this.advertiserInfo.marketId } });
          }
        }
      }
    ];
    this.advertiserInfo = this.route.snapshot.data.advertiserInfo;
    this.autoCompletetConfig.advertiserAutoCompletePromise = this.mktAdvCxtService.autoCompletePromiseSetUp('ADVERTISER', this.advertiserInfo.marketId);
  }
}
